module.exports = __webpack_public_path__ + "static/media/covid19-popup-zh-HK-mobile.3f351e6a.png";